export enum ModalEvent {
    // Modal was dismissed, by backdrop click or cancel btn
    Dismissed = "DIMISSED",
    // User did some action, will vary based on content
    UserDataAction = "USER_ACTION",
}

export enum ModalType {
    Confirm = "CONFIRM",
    Custom = "CUSTOM",
    Notification = "NOTIFICATION",
}

export enum ModalId {
    Profile = "PROFILE",
    ActivationHub = "ACTIVATION_HUB",
    ActivationHubV2 = "ACTIVATION_HUB_V2",
    TRIAL_REMAINING = "TRIAL_REMAINING",
    CleanroomSummary = "CLEANROOM_SUMMARY",
    CleanroomSummaryV2 = "CLEANROOM_SUMMARY_V2",
    SaveAnalysis = "SAVE_ANALYSIS",
    ChooseAnalysis = "CHOOSE_ANALYSIS",
    ChooseAnalysisV2 = "CHOOSE_ANALYSIS_V2",
    UpdatesInProgress = "UPDATES_IN_PROGRESS",
    AddRampIdPartner = "ADD_RAMPID_PARTNER",
    AddAccount = "ADD_ACCOUNT",
    EditAccount = "EDIT_ACCOUNT",
    AddUser = "ADD_USER",
    EditUser = "EDIT_USER",
    RefreshLiveramp = "REFRESH_LIVERAMP",
    AddUserConfirmation = "ADD_USER_CONFIRMATION",
    Error = "ERROR",
    AddSnowflakePartnersAccount = "ADD_SNOWFLAKE_PARTNERS_ACCOUNT",
    EditSnowflakePartnersAccount = "EDIT_SNOWFLAKE_PARTNERS_ACCOUNT",
    EnableCrossCloudConfirmation = "ENABLE_CROSS_CLOUD_CONFIRMATION",
    WelcomeExperience = "WELCOME_EXPERIENCE",
    EditCleanroomFeatures = "EDIT_CLEANROOM_FEATURES",
    ProviderRunEnabled = "PROVIDER_RUN_ENABLED",
    LoaderModal = "LOADER_MODAL",
    AddressColumns = "ADDRESS_COLUMNS",
    CleanroomJoinWarning = "CLEANROOM_JOIN_WARNING",
    ServiceAccountAuthUpdate = "SERVICE_ACCOUNT_AUTH_UPDATE",
    ImageCropper = "IMAGE_CROPPER_MODAL",
    FreeformSQLInfoModal = "FREEFORM_SQL_INFO_MODAL",
    ConfirmSnowflakeAuthModal = "CONFIRM_SNOWFLAKE_AUTH_MODAL",
    ImpactToEnabledTemplates = "IMPACT_TO_ENABLED_TEMPLATES",
    ImpactToDeletedObjects = "IMPACT_TO_DELETED_OBJECTS",
    ImpactToDeletedObjectsOnRunAnalysis = "IMPACT_TO_DELETED_OBJECTS_ON_RUN_ANALYSIS",
    InternalTestEnabled = "INTERNAL_TEST_ENABLED",
    UserAlteredAdminModal = "USER_ALTERED_ADMIN_MODAL",
    NoActiveCollaborators = "NO_ACTIVE_COLLABORATORS",
    SnowflakeErrorModal = "SNOWFLAKE_ERROR_MODAL",
    RequestAdditionalInvites = "REQUEST_ADDITIONAL_INVITES",
    CollaborationUpgrade = "COLLABORATION_UPGRADE",
}
